export const BASE_URL = process.env.VITE_APP_BASE_API_URL ?? '';
export const API_VERSION = '1.0';
